import type {
  DesignerActionFromCreator,
  DesignerStores,
} from '@packages/systems/designer/flux';
import {ExpressionPath} from '@packages/systems/wfdl';
import {
  CONDITIONAL_CREATED_AT,
  CONDITIONAL_OPENED_AT,
  CONDITIONAL_CLOSED,
  CONDITION_GROUP_CREATED_AT,
  conditionalCreatedAt,
  conditionalOpenedAt,
  conditionalClosed,
  conditionGroupCreatedAt,
} from './actions';

type Action =
  | DesignerActionFromCreator<typeof conditionalCreatedAt>
  | DesignerActionFromCreator<typeof conditionalOpenedAt>
  | DesignerActionFromCreator<typeof conditionalClosed>
  | DesignerActionFromCreator<typeof conditionGroupCreatedAt>;

export type ConditionalUIState = {
  autoOpenConditionalPath: ExpressionPath | null;
  autoOpenConditionalGroupPath: ExpressionPath | null;
};

export const initialConditionalUIState: ConditionalUIState = {
  autoOpenConditionalPath: null,
  autoOpenConditionalGroupPath: null,
};

export const getAutoOpenConditionalPath = (
  state: DesignerStores
): ExpressionPath | null => state.ConditionalUIStore.autoOpenConditionalPath;

export const getAutoOpenConditionalGroupPath = (
  state: DesignerStores
): ExpressionPath | null =>
  state.ConditionalUIStore.autoOpenConditionalGroupPath;

export function conditionalUIReducer(
  state: ConditionalUIState = initialConditionalUIState,
  action: Action
): ConditionalUIState {
  switch (action.type) {
    case CONDITIONAL_CREATED_AT:
    case CONDITIONAL_OPENED_AT: {
      const {expressionPath} = action.payload;
      return {
        ...state,
        autoOpenConditionalGroupPath: null,
        autoOpenConditionalPath: expressionPath,
      };
    }
    case CONDITION_GROUP_CREATED_AT: {
      const {expressionPath} = action.payload;
      return {
        ...state,
        autoOpenConditionalPath: null,
        autoOpenConditionalGroupPath: expressionPath,
      };
    }
    case CONDITIONAL_CLOSED: {
      if (state.autoOpenConditionalPath || state.autoOpenConditionalGroupPath) {
        return {
          ...state,
          autoOpenConditionalPath: null,
          autoOpenConditionalGroupPath: null,
        };
      }
      return state;
    }

    default:
      return state;
  }
}
